import Stickyfill from 'stickyfilljs'
// CSS Sticky Polyfill
var elements = document.querySelectorAll('.sticky')
// @ts-ignore
Stickyfill.add(elements)
